import React, { useEffect, useState } from 'react';
import { PropTypes } from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Alert } from 'antd';
import { useIntl } from 'react-intl';
import AccionaButton from '../../../../../components/AccionaButton';
import Modal from '../../../../../components/Modal';
import styles from './index.module.scss';

const { modalContent, tableWrapper } = styles;

const statusIcon = {
  sucess: { className: 'fas fa-check-circle', style: { color: 'green' } },
  uploading: {
    className: 'fas fa-spinner fa-spin',
    style: { color: '#ff0000' },
  },
  waiting: { className: 'fas fa-pause-circle', style: { color: 'orange' } },
  error: { className: 'fas fa-times-circle', style: { color: '#ff0000' } },
};

const UploadResumeModal = ({ uploadFiles, onOk, onCancel }) => {
  const { formatMessage } = useIntl();
  const [isAllFileUpload, setIsAllFileUpload] = useState(false);

  useEffect(() => {
    const { files } = uploadFiles;
    setIsAllFileUpload(() => {
      const sss = files.reduce((filesCompleted, file) => {
        return filesCompleted + (file.status === 'sucess' ? 1 : 0);
      }, 0);
      return sss === uploadFiles.total;
    });
  }, [uploadFiles]);

  return (
    <Modal
      open={uploadFiles.total > 0}
      onCancel={onCancel}
      width="70vw"
      title={<FormattedMessage id={uploadFiles.model || 'title'} />}
    >
      <div className={modalContent}>
        <div className={tableWrapper}>
          <table
            className="dataTable"
            style={{
              border: '2px solid #f1f1f1',
              borderCollapse: 'collapse',
              width: 'calc(100% - 2px)!important',
            }}
          >
            <thead>
              <tr>
                <th>
                  <FormattedMessage id="fileName" />
                </th>
                <th>
                  <FormattedMessage id="status" />
                </th>
                <th>
                  <FormattedMessage id="template" />
                </th>
              </tr>
            </thead>
            <tbody>
              {uploadFiles.files.map((file) => {
                return (
                  <tr key={file.name}>
                    <td>{file.name}</td>
                    <td style={{ textAlign: 'center' }}>
                      <i {...statusIcon[file.status]}></i>
                    </td>
                    <td>{file.template}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        {!isAllFileUpload && (
          <Alert
            message={formatMessage({ id: 'uploadFileInBlock.info.title' })}
            description={formatMessage({
              id: 'uploadFileInBlock.info.description',
            })}
            type="warning"
            showIcon
            style={{ margin: '20px 10px 0 10px' }}
          />
        )}
        <div
          className="form-row align-right-sd no-table"
          style={{ paddingTop: '20px' }}
        >
          <AccionaButton
            id="deleteBtn"
            disabled={uploadFiles.uploading}
            onClick={onOk}
            msg={<FormattedMessage id="close" />}
          />
        </div>
      </div>
    </Modal>
  );
};

UploadResumeModal.propTypes = {
  uploadFiles: PropTypes.shape({
    total: PropTypes.number,
    model: PropTypes.string,
    files: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        status: PropTypes.string,
        template: PropTypes.string,
      }),
    ),
    uploading: PropTypes.bool,
  }).isRequired,
  onOk: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};
export default UploadResumeModal;
